import React from 'react';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from './ui/tooltip';
import { RotatingDeleteIcon } from './RotatingDeleteIcon';
import { cn } from '@/lib/utils';

interface RotatingDeleteButtonProps {
  onClick: () => void;
  tooltipText?: string;
  ariaLabel?: string;
  className?: string;
  disabled?: boolean;
}

export const RotatingDeleteButton: React.FC<RotatingDeleteButtonProps> = ({
  onClick,
  tooltipText = 'Remove',
  ariaLabel,
  className = '',
  disabled = false,
}) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex">
            <button
              onClick={disabled ? undefined : onClick}
              disabled={disabled}
              className={cn(
                'group flex shrink-0 items-center justify-center rounded-md border-none bg-transparent transition-all duration-200',
                className.includes('p-0') ? 'p-0' : 'p-2',
                disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
                className,
              )}
              style={{
                color: 'var(--muted-foreground)',
              }}
              onMouseEnter={(e) => {
                if (!disabled) {
                  e.currentTarget.style.backgroundColor = 'var(--muted)';
                  e.currentTarget.style.color = 'var(--destructive)';
                }
              }}
              onMouseLeave={(e) => {
                if (!disabled) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = 'var(--muted-foreground)';
                }
              }}
              aria-label={ariaLabel || tooltipText}
            >
              <RotatingDeleteIcon size={20} className="h-5 w-5" />
            </button>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
